import {Component, OnInit} from '@angular/core';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {_windowUtil} from "../../utils/ui-utils"

declare var $: any;
declare var AB: any;

@Component({
    selector: 'app-freshpass-faq',
    templateUrl: './freshpass-faq.component.html',
    styleUrls: ['./freshpass-faq.component.scss'],
    providers: [SubscriptionService]
})
export class FreshpassFaqComponent implements OnInit {
    currentEnvironment;
    frequentlyAskedQuestion = '';
    public windowUtil = _windowUtil(window);
    constructor(
        public subscriptionService: SubscriptionService) {
    }
  
    ngOnInit(): void {
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        this.subscriptionService.getFrequentlyAskedComponent(this.currentEnvironment).subscribe(data => {
            if (data) {
                this.frequentlyAskedQuestion = data;
                setTimeout(() => {
                    $('.accordion-header').toggleClass('inactive-header');
                    $('.addRole').each(function () {
                      $(this).attr('role', 'text');
                    })

                    $('.display-type').each(function () {
                        var displayType = $(this).attr("data-display-type");
                        if (displayType == 'expandFirst') {
                            $(this).find('.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
                            $(this).find('.accordion-content').first().slideDown().toggleClass('open-content');
                        } else if (displayType == 'expanded') {
                            $(this).find('.accordion-header').toggleClass('active-header').toggleClass('inactive-header');
                            $(this).find('.accordion-content').slideDown().toggleClass('open-content');
                        }
                    });

                    // The Accordion Effect
                    $(".accordion-header").each(function () {
                        if ($(this).hasClass('active-header')) {
                            $('.accordion-header').attr('aria-expanded', 'true');
                        } else {
                            $(this).attr('aria-expanded', 'false');
                        }
                    });

                    $('.accordion-header').click(function () {
                        if ($(this).is('.inactive-header')) {
                            $(this).toggleClass('active-header').toggleClass('inactive-header');
                            $(this).attr('aria-expanded', 'true');
                            $(this).next().slideToggle().toggleClass('open-content');

                        } else {
                            $(this).toggleClass('active-header').toggleClass('inactive-header');
                            $(this).attr('aria-expanded', 'false');
                            $(this).next().slideToggle().toggleClass('open-content');
                        }
                    });

                    $('.accordion-header').keypress(function (e) {
                        var key = e.which;
                        if (key == 13) {
                            if ($(this).is('.inactive-header')) {
                                $(this).toggleClass('active-header').toggleClass('inactive-header');
                                $(this).attr('aria-expanded', 'true');
                                $(this).next().slideToggle().toggleClass('open-content');

                            } else {
                                $(this).toggleClass('active-header').toggleClass('inactive-header');
                                $(this).attr('aria-expanded', 'false');
                                $(this).next().slideToggle().toggleClass('open-content');
                            }
                        }

                    });
                }, 2000);
            }
        });
    }

    openManageFreshpass() {
        this.windowUtil.setWindowLocationHref('/freshpass/manage');
    }

    openHomepage() {
        this.windowUtil.setWindowLocationHref('/shop/home.html');
    }
}
